import React from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
// Re-use this same Alert for View Receipt also.
export var ViewReceiptAlert = function (_a) {
    var status = _a.status, message = _a.message, onClose = _a.onClose;
    return (React.createElement(Alert, { status: status, onClose: onClose }, message));
};
